import { combineEpics, ofType } from 'redux-observable'
import { EMPTY } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'

import { SAVE_DEFAULT_TIMEFRAME, saveDefaultTimeFrameSuccess } from './actions'

// Persists the user's personal default time-frame favorite (user-scoped, not company IR settings).
// Clicking the active star posts `null` to clear. State is patched only from the response so the
// star (active favorite vs faded company-default hint) updates after the server confirms.
const saveDefaultTimeFrameEpic = (action$, _store, { api }) =>
  action$.pipe(
    ofType(SAVE_DEFAULT_TIMEFRAME),
    switchMap(({ payload: { df } }) =>
      api.accounts.setDefaultIncidentTimeframe(df).pipe(
        map((response) => {
          const next =
            response &&
            Object.prototype.hasOwnProperty.call(response, 'userDefaultIncidentDateFilter')
              ? response.userDefaultIncidentDateFilter
              : df
          return saveDefaultTimeFrameSuccess(next ?? null)
        }),
        catchError(() => EMPTY)
      )
    )
  )

export default combineEpics(saveDefaultTimeFrameEpic)
